import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../app-settings';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };

  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) { }

  login(loginData: object) {
    return this.http
      .post<any>(AppSettings.API_URI_V2 + '/login', loginData, this.formHeaders)
      .pipe(
        map((jwt) => {
          if (jwt.access_token) {
            localStorage.setItem('jwt_token', jwt.access_token);
          }

          return jwt;
        })
      );
  }

  check() {
    const url = `${AppSettings.API_URI_V2}/auth/me`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        let roles = response.data.roles.map((role: any) => role.name);
        if (roles.includes('admin') || roles.includes('superadmin')) {
          return response;
        }

        return response;
      })
    );
  }

  refreshToken() {
    return this.http
      .get<any>(AppSettings.API_URI_V2 + '/auth/refresh', this.formHeaders)
      .pipe(
        map((jwt) => {
          if (jwt.access_token) {
            localStorage.setItem('jwt_token', jwt.access_token);
          }
          return jwt;
        })
      );
  }

  // Método para subscribirse al token actualizado
  getRefreshTokenSubject(): Observable<any> {
    return this.refreshTokenSubject.asObservable();
  }

  async setToken(token: string) {
    localStorage.setItem('jwt_token', token);
  }

  logout() {
    localStorage.removeItem('jwt_token');
  }
}



